import {
  changeFieldValue,
  changeFieldValueAndUpdate,
  getFormValues,
  getQuestion,
  getSection,
  setMessageVisibility,
  setQuestionVisibility,
} from 'app/services/businessFunctionHelpers';
import { getConsentsValues } from 'app/shared/helpers/getConsentsValues';
import { FieldsEnum, FormsEnum, SectionsEnum } from 'app/shared/enums';
import { QuestionInterface } from 'app/shared/interfaces/Question.interface';

const consents = {
  fillAllRequiredCalculationConsents(initialRun: boolean) {
    if (initialRun) return;

    const value = getFormValues().consent.all.calculation;
    const sectionKey = SectionsEnum.ShortCalculationPath;
    const section = getSection(sectionKey, FormsEnum.CalculationForm);

    section?.questions
      .map((questionKey: FieldsEnum) =>
        getQuestion(questionKey, FormsEnum.CalculationForm)
      )
      .filter(
        (question: QuestionInterface) =>
          question.key.startsWith('consent.') &&
          question.key !== 'consent.all.calculation' &&
          question.visible
      )
      .forEach((question: QuestionInterface) =>
        changeFieldValueAndUpdate(
          question.key,
          value,
          FormsEnum.CalculationForm
        )
      );

    setQuestionVisibility({
      key: FieldsEnum.InsuranceMarketingEmailConsent,
      visible: !value,
      formName: FormsEnum.CalculationForm,
    });

    setTimeout(() => {
      changeFieldValue(
        FieldsEnum.ButtonConsentsCalculation,
        value,
        FormsEnum.CalculationForm
      );
    }, 0);
  },
  fillAllRequiredMubiLeasingConsents(initialRun: boolean) {
    if (initialRun) return;

    const value = getFormValues().consent.all.mubiLeasing;
    const sectionKey = SectionsEnum.MubiLeasingSectionConsents;
    const section = getSection(sectionKey, FormsEnum.CalculationForm);

    section?.questions
      .map((questionKey: FieldsEnum) =>
        getQuestion(questionKey, FormsEnum.CalculationForm)
      )
      .filter(
        (question: QuestionInterface) =>
          question.key.startsWith('consent.') &&
          question.key !== 'consent.all.mubiLeasing' &&
          question.visible
      )
      .forEach((question: QuestionInterface) =>
        changeFieldValueAndUpdate(
          question.key,
          value,
          FormsEnum.CalculationForm
        )
      );
  },
  requiredCalculationConsentChange() {
    const { regulationsConsentValue } = getConsentsValues();

    if (regulationsConsentValue) {
      setMessageVisibility({
        key: 'regulationsConsentRequiredToGetCepikData',
        visible: false,
        formName: FormsEnum.CalculationForm,
      });
    } else {
      changeFieldValue(
        FieldsEnum.ButtonConsentsCalculation,
        false,
        FormsEnum.CalculationForm
      );
    }
  },
  onCepikConsentChange() {
    const { cepikConsentValue } = getConsentsValues();

    if (cepikConsentValue) {
      setMessageVisibility({
        key: 'cepikConsentRequiredToGetCepikData',
        visible: false,
        formName: FormsEnum.CalculationForm,
      });
    } else {
      changeFieldValue(
        FieldsEnum.ButtonConsentsCalculation,
        false,
        FormsEnum.CalculationForm
      );
    }
  },
};

export default consents;
